import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import GradingSystem from "../views/GradingSystem.vue";
import NonGradingSystem from "../views/NonGradingSystem.vue";
import LateralEntry from "../views/LateralEntry.vue";
import CBCS from "../views/CBCS.vue";
import CBGS from "../views/CBGS.vue";
import AsPerCOA from "../views/AsPerCOA.vue";
import FallBack from "../views/404.vue";
import VueMeta from "vue-meta";

Vue.use(VueRouter);

Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true,
});

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/Grading-System",
    name: "Grading System",
    component: GradingSystem,
  },
  {
    path: "/non-grading-system",
    name: "Non Grading System",
    component: NonGradingSystem,
  },
  {
    path: "/Lateral-Entry",
    name: "Lateral Entry",
    component: LateralEntry,
  },
  {
    path: "/CBCS",
    name: "CBCS",
    component: CBCS,
  },
  {
    path: "/CBGS",
    name: "CBGS",
    component: CBGS,
  },
  {
    path: "/As-Per-COA",
    name: "As per COA",
    component: AsPerCOA,
  },
  {
    path: "/*",
    name: "Fall Back",
    component: FallBack,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
